<template>
  <el-row
    type="flex"
    justify="space-between"
    :class="{ 'is-vertical': isMobile }"
  >
    <div class="dashboard-detail--title">
      <template v-if="isEveryDay">
        <span ref="title">
          {{ $t("component.date.picker." + interval)
          }}{{ $t("page.dashboard.detail.header.title[1]") }}
        </span>
        <tg-button
          theme="dashboard-export"
          round
          activeGradient
          @click.native="handleExport"
        >
          <template slot="icon" slot-scope="scope">
            <i
              class="tg-icon tg-icon-export"
              :class="{ active: scope.isHover }"
            ></i>
          </template>
          {{ $t("component.btn.export") }}
        </tg-button>
      </template>
      <template v-else>
        <span>{{ $t("page.dashboard.detail.header.title[0]") }}</span>
        <span class="dashboard-detail--title-subject">
          <span>{{ $t("component.date.picker." + interval) }}</span>
          <span>{{ subject }}</span>
          <span>{{ total }}</span>
        </span>
        <span class="dashboard-detail--title-icon">
          <el-tooltip placement="bottom" effect="dashboard-tip">
            <div
              slot="content"
              class="dashboard-tip--content"
              v-html="parseDetailTip()"
            ></div>
            <el-avatar :size="24">
              <i class="tg-icon tg-icon-tip--green col-12"></i>
            </el-avatar>
          </el-tooltip>
        </span>
      </template>
    </div>
    <div class="dashboard-detail--time" v-show="time">
      {{ $t("page.dashboard.detail.header.time") }}: {{ time }}
    </div>
  </el-row>
</template>

<script>
import TgButton from "@/components/button/TgButton.vue";
export default {
  name: "DashboardDetailHeader",
  components: {
    TgButton,
  },
  props: {
    subject: String,
    interval: String,
    time: String,
    total: [String, Number],
    subjectKey: String,
    // 是否為 每日明細
    isEveryDay: Boolean,
  },
  methods: {
    parseDetailTip() {
      let content = "<ul>";
      let key = ["descript", "detail"];

      key.forEach((item) => {
        let k = "page.dashboard-tips." + this.subjectKey + "." + item;

        if (this.$te(k)) {
          content += "<li>" + this.$t(k) + "</li>";
        }
      });

      let notInclude = this.$t(
        "page.dashboard-tips." + this.subjectKey + ".notInclude"
      );
      if (notInclude) {
        content += "<li>"+this.$t("page.dashboard-tips.notInclude")+"：<br>";
        content += notInclude + "<br>";
        content += "</li>";
      }
      

      content += "</ul>";
      return content;
    },
    handleIconClick() {
      this.$confirm(this.parseDetailTip(), this.subject, {
        showConfirmButton: false,
        showClose: false,
        showCancelButton: false,
        dangerouslyUseHTMLString: true,
      }).catch(() => {});
    },
    handleExport() {
      this.$emit("on-export", this.$refs.title.innerText);
    },
  },
};
</script>
